export default __webpack_public_path__ + "static/media/inverted-mobile-menu.c99676b0.svg";